import { render } from "./dialog-approval.vue?vue&type=template&id=445717cb&scoped=true&ts=true"
import script from "./dialog-approval.vue?vue&type=script&lang=ts"
export * from "./dialog-approval.vue?vue&type=script&lang=ts"

import "./dialog-approval.vue?vue&type=style&index=0&id=445717cb&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-445717cb"]])

export default __exports__